const toNonNegativeNumber = (value) => {
  const parsedValue = Number(value)

  return Number.isFinite(parsedValue) ? Math.max(parsedValue, 0) : 0
}

export const buildCumulativeWaterData = (daily) => {
  let cumulativePrecipitationMm = 0
  let cumulativeReferenceEt0Mm = 0

  return (Array.isArray(daily) ? daily : []).map((item = {}) => {
    cumulativePrecipitationMm += toNonNegativeNumber(item.precipitationMm)
    cumulativeReferenceEt0Mm += toNonNegativeNumber(item.referenceEt0Mm)

    return {
      date: item.date || '',
      cumulativePrecipitationMm,
      cumulativeReferenceEt0Mm,
      accumulatedClimaticDeficitMm: Math.max(
        cumulativeReferenceEt0Mm - cumulativePrecipitationMm,
        0
      ),
    }
  })
}

export const summarizeAccumulatedClimaticDeficit = (cumulativeData) => {
  const values = Array.isArray(cumulativeData) ? cumulativeData : []
  const finalValue = values[values.length - 1]
  const peakValue = values.reduce(
    (peak, item) =>
      item.accumulatedClimaticDeficitMm > peak.accumulatedClimaticDeficitMm ? item : peak,
    {
      date: '',
      accumulatedClimaticDeficitMm: 0,
    }
  )

  return {
    hasDeficit: peakValue.accumulatedClimaticDeficitMm > 0.01,
    peakDate: peakValue.date,
    peakDeficitMm: peakValue.accumulatedClimaticDeficitMm,
    closingDeficitMm: finalValue?.accumulatedClimaticDeficitMm || 0,
  }
}
